export enum LoginPageKeys {
  loginPage_loginPrompt = "loginPage_loginPrompt",
  loginPage_emailPlaceholder = "loginPage_emailPlaceholder",
  loginPage_passwordPlaceholder = "loginPage_passwordPlaceholder",
  loginPage_loginBtn = "loginPage_loginBtn",
  loginPage_forgetPasswordBtn = "loginPage_forgetPasswordBtn",
}
